export default "__VITE_PUBLIC_ASSET__2b5542ea__"